import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import Img from 'react-image';
import { Table, Td, Th, Tr } from 'oxyrion-ui/lib/Table';
import styled from 'styled-components';
import { Select, Button, Loader } from 'oxyrion-ui/lib';
import {
  __,
  formatColorToRGB,
  formatPrice,
  formatNumber,
  formatNumberTo148YUS,
  round,
} from '../../Utils';
import API2 from '../../API2';

const Wrapper = styled.div`
  font-size: ${rem(14)};
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const MainWrapper = styled.div``;

const Space = styled.div`
  height: ${rem(20)};
  width: ${rem(20)};
`;

const SmallSpace = styled.div`
  height: ${rem(4)};
  width: ${rem(4)};
`;

const Label = styled.div`
  font-weight: bold;
  margin-bottom: ${rem(2)};
  font-size: ${rem(14)};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${rem(4)};
`;

const UFIInfo = styled.div`
  color: red;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const Text = styled.div`
  margin-bottom: ${rem(8)};
  font-size: ${rem(14)};
`;

const ItemCube = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  width: ${rem(180)};
  height: ${rem(180)};
  border: solid 1px #d3d3d3;
  position: relative;
  padding: ${rem(4)};
`;

const ItemInCube = styled.div`
  font-size: ${rem(12)};
`;

const BoldText = styled.div`
  font-weight: 900;
  margin-right: ${rem(4)};
`;

const ColorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${rem(8)};
  border-bottom: solid 1px #e6e6e6;
`;

const ColorSmallLabel = styled.div`
  height: ${rem(24)};
  width: ${rem(24)};
  background: ${props => props.color};
`;

const ColorCode = styled.div`
  margin-left: ${rem(8)};
  margin-right: ${rem(8)};
  width: ${rem(50)};
`;
const ColorVolume = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => (props.red ? 'red' : 'black')};
`;

const NotAbleToTinting = styled.div`
  font-size: ${rem(24)};
  color: red;
  font-weight: bold;
  width: ${rem(8)};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: ${rem(4)};
`;

const TextNoMargin = styled(Text)`
  margin-bottom: 0;
  margin-left: ${rem(8)};
`;

const NoData = styled.div`
  color: #737373;
  font-weight: 100;
  font-size: 14px;
`;

const RecipeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${rem(250)};
`;

const ColouratsLabel = styled.div`
  color: red;
  margin-right: ${rem(14)};
  font-size: ${rem(16)};
`;

const BaseWrapper = styled.div`
  display: flex;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

const DetailImage = styled(Img)`
  height: ${rem(100)};
`;

const ImageWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Parter1 = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;

  @media (min-width: 1500px) {
    flex-direction: row;
  }
`;

const Parter = styled.div`
  display: flex;
  @media (min-width: 1500px) {
    flex-direction: row;
  }
`;

const ContetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 1500px) {
    flex-direction: row;
  }
`;

const CustomTableTr = styled(Tr)`
  border: none;
`;

const CustomTableTd = styled(Td)`
  padding-top: 0;
  padding-bottom: 0;
  font-size: ${rem(14)};
`;

const CustomTableTh = styled(Th)`
  font-weight: 800;
  font-size: ${rem(14)};
`;

const CustomTableTdBold = styled(CustomTableTd)`
  font-weight: 800;
  font-size: ${rem(14)};
`;

const photoBasePath = `${process.env.REACT_APP_IMAGES_PREFIX}/images/650x0`;

class FourthStep extends React.Component {
  state = {
    selectedVolume: 'ml',
    units: ['ml'],

    // selectedFinishedEffect: '',
  };

  async componentDidMount() {
    try {
      const result = await API2.getB2BCodeListAction('jednotky_tonovac');

      this.setState({
        units: result.codelist.map(c => c.label),
      });
    } catch (e) {
      console.log(e);
    }
  }

  getPrice(selectedPrice, quantity, complementarProduct, complementarQuantity) {
    return (
      (selectedPrice.price
        ? selectedPrice.price.amount
        : selectedPrice.default_price.amount) *
        quantity +
      (complementarProduct && complementarQuantity > 0
        ? complementarProduct.price_wd.amount * complementarQuantity
        : 0)
    );
  }

  getPriceVat(
    selectedPrice,
    quantity,
    complementarProduct,
    complementarQuantity,
  ) {
    return (
      (selectedPrice.price_vat
        ? selectedPrice.price_vat.amount
        : selectedPrice.default_price.amount) *
        quantity +
      (complementarProduct && complementarQuantity > 0
        ? complementarProduct.price_wd_vat.amount * complementarQuantity
        : 0)
    );
  }

  getTotalVolume(
    complementarProduct,
    complementarQuantity,
    totalColorantsVolume,
    selectedVariantVolume,
  ) {
    return complementarProduct && complementarQuantity > 0
      ? (
          totalColorantsVolume +
          selectedVariantVolume +
          complementarProduct.volume
        ).toFixed(2)
      : (totalColorantsVolume + selectedVariantVolume).toFixed(2);
  }
  handleUnitChange(value) {
    this.setState({
      selectedVolume: value,
    });
  }

  render() {
    const {
      prices,
      // availableBases,
      color,
      // shadeProperties,
      // shadeOfBase,

      confirmButtonTitle,
      onConfirm,
      product,
      quantity,
      complementarQuantity,
      complementarProduct,
      showButton,
      colorcardName,
    } = this.props;
    const {
      selectedVolume,
      units,
      // selectedFinishedEffect,
    } = this.state;

    const selectedVariantVolume =
      product && product.volume ? Number(product.volume.replace(',', '.')) : 0;

    const selectedPrice = prices.find(p => product && p._id === product._id);

    let totalColorantsVolume = 0;
    let totalColorantsVolumeMl = 0;

    const colourantsOverTrashold = [];

    if (selectedPrice && selectedPrice.colourants)
      selectedPrice.colourants.forEach(c => {
        if (c.trasholdValue && c.pigmentPortion >= c.trasholdValue) {
          colourantsOverTrashold.push(c._id);
        }

        totalColorantsVolume += c.value / 1000;
        totalColorantsVolumeMl += Number(
          (c.values_in_units[selectedVolume] &&
            c.values_in_units[selectedVolume].real_value) ||
            c.value,
        );
      });

    return (
      <MainWrapper>
        <Wrapper>
          {prices && prices.length ? (
            <ContetWrapper>
              <Parter1>
                {selectedPrice &&
                selectedPrice.colourants &&
                selectedPrice.colourants.length ? (
                  <RecipeWrapper>
                    {colorcardName && (
                      <Row style={{ justifyContent: 'space-between' }}>
                        <Label style={{ marginRight: rem(8) }}>
                          {__('Vzorkovník:')}
                        </Label>
                        <SmallSpace />
                        {colorcardName}
                      </Row>
                    )}
                    <Row style={{ justifyContent: 'space-between' }}>
                      <Label style={{ marginRight: rem(8) }}>
                        {__('Receptúra:')}
                      </Label>
                      <SmallSpace />
                      <Select
                        value={selectedVolume}
                        size="s"
                        style={{ width: rem(120) }}
                        onChange={e => this.handleUnitChange(e.target.value)}
                      >
                        {units.map(u => (
                          <option selected={selectedVolume === u}>{u}</option>
                        ))}
                      </Select>
                    </Row>
                    {selectedPrice.colourants.map(c => (
                      <ColorWrapper>
                        <Row>
                          <ColorSmallLabel color={formatColorToRGB(c.color)} />
                          <ColorCode>{c._id}</ColorCode>
                        </Row>
                        <ColorVolume
                          red={
                            c.trasholdValue &&
                            c.pigmentPortion >= c.trasholdValue
                          }
                        >
                          {`${
                            c.values_in_units[selectedVolume].formated_value
                          } ${
                            c.trasholdValue ? `(${c.pigmentPortion} %)` : ''
                          }`}
                          {c.not_in_machine && (
                            <NotAbleToTinting title={__('Nedá sa natónovať')}>
                              !
                            </NotAbleToTinting>
                          )}
                        </ColorVolume>
                      </ColorWrapper>
                    ))}
                    <Row style={{ justifyContent: 'space-between' }}>
                      <BaseWrapper>
                        <Label style={{ fontSize: rem(18) }}>
                          {__('Báza:')}
                        </Label>
                        <TextNoMargin style={{ fontSize: rem(18) }}>
                          {prices
                            .filter(p => p.base)
                            .map(p => p.base)
                            .filter(
                              (value, index, self) =>
                                self.indexOf(value) === index,
                            )
                            .join(',')}
                        </TextNoMargin>
                      </BaseWrapper>
                      <ColouratsLabel>
                        {selectedVolume === '1/48Y US'
                          ? formatNumberTo148YUS(totalColorantsVolumeMl)
                          : formatNumber(round(totalColorantsVolumeMl, 1))}
                      </ColouratsLabel>
                    </Row>
                  </RecipeWrapper>
                ) : (
                  <div />
                )}
                <Space />
                {color && (
                  <Col>
                    <Label>{__('Odtieň')}</Label>
                    <SmallSpace />
                    <ItemCube
                      style={{
                        background: `rgb(${color.color.R},${color.color.G},${
                          color.color.B
                        })`,
                      }}
                    >
                      {/* <ItemInCube>
                      {color.color_base_name || color.color_name}
                    </ItemInCube> */}
                      <ItemInCube>
                        {color.color_base_name || color.color_name}
                      </ItemInCube>
                    </ItemCube>
                  </Col>
                )}
              </Parter1>
              <Space />
              <Parter>
                {product && (
                  <Col>
                    <Label>{__('Produkt')}</Label>
                    <SmallSpace />
                    <ItemCube>
                      <ImageWrapper>
                        <DetailImage
                          src={[`${photoBasePath}/${product.image_full_path}`]}
                          loader={<Loader color="#1D71B8" />}
                        />
                      </ImageWrapper>

                      <ItemInCube>{product.name}</ItemInCube>
                      {complementarProduct && complementarQuantity > 0 && (
                        <ItemInCube>
                          <BoldText>{__('Tužidlo')}</BoldText>
                          {`${
                            complementarProduct.name
                          } x ${complementarQuantity}`}
                        </ItemInCube>
                      )}
                    </ItemCube>
                  </Col>
                )}
                {/* </CenterWrapper> */}
                {/* {calculatedColorants.length ? <Line /> : <div />} */}
                <Space />
                {selectedPrice && (
                  <Col>
                    <Label>{__('Sumár')}</Label>
                    <SmallSpace />
                    <Table style={{ background: '#f7f7f7' }} width="100%">
                      <CustomTableTr>
                        <CustomTableTh />
                        <CustomTableTh>{__('Cena')}</CustomTableTh>
                        <CustomTableTh>{__('Objem / Hmotnosť')}</CustomTableTh>
                      </CustomTableTr>
                      <CustomTableTr>
                        <CustomTableTdBold>{__('Farba')}</CustomTableTdBold>
                        <CustomTableTd>
                          {`${formatPrice(
                            selectedPrice.default_price || selectedPrice.price,
                          )}`}
                        </CustomTableTd>
                        <CustomTableTd>
                          {selectedVariantVolume && `${selectedVariantVolume}l`}
                        </CustomTableTd>
                      </CustomTableTr>
                      {selectedPrice.default_price && (
                        <CustomTableTr>
                          <CustomTableTdBold>
                            {__('Tónovanie')}
                          </CustomTableTdBold>
                          <CustomTableTd>{`${formatPrice({
                            amount:
                              selectedPrice.price.amount -
                              selectedPrice.default_price.amount,
                            currency: selectedPrice.price.currency,
                          })}`}</CustomTableTd>
                          <CustomTableTd>
                            {totalColorantsVolume &&
                              `${totalColorantsVolume.toFixed(2)}l`}
                          </CustomTableTd>
                        </CustomTableTr>
                      )}
                      {complementarProduct && complementarQuantity > 0 && (
                        <CustomTableTr>
                          <CustomTableTdBold>
                            {__('Hotový odtieň')}
                          </CustomTableTdBold>
                          <CustomTableTd>
                            {formatPrice(
                              selectedPrice.price ||
                                selectedPrice.default_price,
                            )}
                          </CustomTableTd>
                          <CustomTableTd>
                            {totalColorantsVolume &&
                              `${(
                                totalColorantsVolume + selectedVariantVolume
                              ).toFixed(2)}l`}
                          </CustomTableTd>
                        </CustomTableTr>
                      )}
                      {complementarProduct && complementarQuantity > 0 && (
                        <CustomTableTr>
                          <CustomTableTdBold>{__('Tužidlo')}</CustomTableTdBold>
                          <CustomTableTd>
                            {complementarProduct &&
                              complementarQuantity > 0 &&
                              formatPrice(complementarProduct.price_wd)}
                          </CustomTableTd>
                          <CustomTableTd>
                            {complementarProduct &&
                              complementarQuantity > 0 &&
                              `${complementarProduct.volume}l`}
                          </CustomTableTd>
                        </CustomTableTr>
                      )}
                      <CustomTableTr>
                        <CustomTableTdBold>{__('Spolu')}</CustomTableTdBold>
                        <CustomTableTd>
                          {formatPrice({
                            amount:
                              (selectedPrice.price
                                ? selectedPrice.price.amount
                                : selectedPrice.default_price.amount) +
                              (complementarProduct &&
                                complementarQuantity > 0 &&
                                complementarProduct.price_wd.amount),
                            currency: selectedPrice.default_price.currency,
                          })}
                        </CustomTableTd>
                        <CustomTableTd>
                          {`${this.getTotalVolume(
                            complementarProduct,
                            complementarQuantity,
                            totalColorantsVolume,
                            selectedVariantVolume,
                          )}l`}
                        </CustomTableTd>
                      </CustomTableTr>
                      <CustomTableTr>
                        <CustomTableTdBold>
                          {__('Počet kusov')}
                        </CustomTableTdBold>
                        <CustomTableTd>{quantity}</CustomTableTd>
                        <CustomTableTd />
                      </CustomTableTr>
                      <CustomTableTr>
                        <CustomTableTdBold>
                          {__('Celková cena bez dph')}
                        </CustomTableTdBold>
                        <CustomTableTd>
                          {formatPrice({
                            amount: this.getPrice(
                              selectedPrice,
                              quantity,
                              complementarProduct,
                              complementarQuantity,
                            ),
                            currency: selectedPrice.default_price.currency,
                          })}
                        </CustomTableTd>
                        <CustomTableTd>
                          {`${formatPrice({
                            amount:
                              ((selectedPrice.price
                                ? selectedPrice.price.amount
                                : selectedPrice.default_price.amount) +
                                (complementarProduct &&
                                  complementarQuantity > 0 &&
                                  complementarProduct.price_wd.amount)) /
                              this.getTotalVolume(
                                complementarProduct,
                                complementarQuantity,
                                totalColorantsVolume,
                                selectedVariantVolume,
                              ),
                            currency: selectedPrice.default_price.currency,
                          })}/l`}
                        </CustomTableTd>
                      </CustomTableTr>
                      <CustomTableTr>
                        <CustomTableTdBold>
                          {__('Celková cena s dph')}
                        </CustomTableTdBold>
                        <CustomTableTd>
                          {formatPrice({
                            amount: this.getPriceVat(
                              selectedPrice,
                              quantity,
                              complementarProduct,
                              complementarQuantity,
                            ),
                            currency: selectedPrice.default_price.currency,
                          })}
                        </CustomTableTd>
                        <CustomTableTd>
                          {`${formatPrice({
                            amount:
                              ((selectedPrice.price_vat
                                ? selectedPrice.price_vat.amount
                                : selectedPrice.default_price.amount) +
                                (complementarProduct &&
                                  complementarQuantity > 0 &&
                                  complementarProduct.price_wd_vat.amount)) /
                              this.getTotalVolume(
                                complementarProduct,
                                complementarQuantity,
                                totalColorantsVolume,
                                selectedVariantVolume,
                              ),
                            currency: selectedPrice.default_price.currency,
                          })}/l`}
                        </CustomTableTd>
                      </CustomTableTr>
                    </Table>

                    {showButton && (
                      <Row
                        style={{
                          justifyContent: 'flex-end',
                          marginTop: rem(16),
                        }}
                      >
                        <Button
                          small
                          onClick={() =>
                            onConfirm({
                              count: quantity,
                              selectedVariantVolume,
                              product: selectedPrice,
                              complementarProduct,
                              complementarQuantity,
                            })
                          }
                          primary
                        >
                          {confirmButtonTitle}
                        </Button>
                      </Row>
                    )}
                  </Col>
                )}
              </Parter>
            </ContetWrapper>
          ) : (
            <NoData>
              {__(
                'Farbu momentálne nie je možné natónovať na požadovaný odtieň',
              )}
            </NoData>
          )}
        </Wrapper>
        {colourantsOverTrashold.length > 0 && (
          <Row>
            <UFIInfo>
              {`${__(
                'RECEPTÚRA OBSAHUJE PIGMENT',
              )} ${colourantsOverTrashold.join(', ')} ${__(
                'NALEPTE NA OBAL ŠTÍTOK S UFI KÓDOM, PROSÍM',
              )}`}
            </UFIInfo>
          </Row>
        )}
      </MainWrapper>
    );
  }
}
FourthStep.propTypes = {
  history: PropTypes.shape({}).isRequired,
  prices: PropTypes.arrayOf({}),
  // availableBases: PropTypes.arrayOf({}),
  // shadeProperties: PropTypes.arrayOf(PropTypes.string),
  colorants: PropTypes.arrayOf({}),
  // shadeOfBase: PropTypes.string,
  confirmButtonTitle: PropTypes.string,
  onConfirm: PropTypes.func,
  product: PropTypes.shape({}),
  complementarProduct: PropTypes.shape({}),
  complementarQuantity: PropTypes.number,
  colorcardName: PropTypes.string,
  quantity: PropTypes.number,
  showButton: PropTypes.bool,
  color: PropTypes.shape({
    color_code: PropTypes.string,
    color_group: PropTypes.string,
    color: PropTypes.shape({
      R: PropTypes.number,
      G: PropTypes.number,
      B: PropTypes.number,
    }),
  }),
};

FourthStep.defaultProps = {
  prices: [],
  // availableBases: [],
  // shadeProperties: [],
  colorants: [],
  // shadeOfBase: '',
  confirmButtonTitle: 'Exportovať',
  color: null,
  onConfirm: () => {},
  product: {},
  complementarProduct: {},
  quantity: 0,
  complementarQuantity: 0,
  showButton: true,
};

export default FourthStep;



// WEBPACK FOOTER //
// ./src/Containers/Toning/fourthStep.jsx